import {
  UPDATE_PRODUCT_DESTINATION,
  UPDATE_PRODUCT_LOCATION,
  DETECT_TYPE_OF_CODE_REQUESTED,
  DETECT_TYPE_OF_CODE_SUCCESSED,
  MAP_DESTINATION_TO_PRODUCT,
  SKIP_DISPUTE_ITEM
} from './batch.actions';
import * as _ from 'lodash';
import { UPDATED_DESTINATION_LOCATIONS_REQUESTED } from '../list/list.action';

const ProductLocation = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_DESTINATION:
      if (action.item.getId() === (state as any).getId()) {
        state = _.assign(state, {
          destination_id: action.data.getId(),
          destination: action.data
        });
      }
      return state;
    case UPDATE_PRODUCT_LOCATION:
      if (action.item.getId() === (state as any).getId()) {
        state = _.assign(state, {
          location_id: action.data.getId(),
          location: action.data
        });
      }
      return state;
    default:
      return state;
  }
};

const Code = (state: any = {}, action) => {
  switch (action.type) {
    case DETECT_TYPE_OF_CODE_SUCCESSED:
      let field;
      if (action.kind === 'product') {
        field = 'sku';
      } else if (action.kind === 'location') {
        field = 'code';
      }
      const f = _.find(action.data, item => item[field] === state.code);
      if (!_.isUndefined(f)) {
        state = _.assign({}, state, { data: f, kind: action.kind });
      } else {
        if (!state.kind) {
          state = _.assign({}, state, { data: null, kind: 'unknown' });
        }
      }
      return state;
    case MAP_DESTINATION_TO_PRODUCT:
      if (state.kind === 'product' && !_.isNil(state.data.destination_id)) {
        const des = _.find(action.data, item => item.getId() === state.data.getDestinationId());
        if (!_.isUndefined(des)) {
          state = _.assign(_.clone(state), { data: _.assign(state.data, { current_destination: des }) });
          if (!_.isNil(state.data.location_id)) {
            state = _.assign(_.clone(state), { data: _.assign(state.data, { current_location: _.find(des.locations, loc => loc.getId() === state.data.getLocationId()) }) });
          }
        }
      }
      return state;
    case UPDATE_PRODUCT_DESTINATION:
      if (state.data.getId() === action.item.getId()) {
        state = _.assign({}, state, {
          data: _.assign(state.data, {
            destination_id: action.data.getId()
          })
        });
      }
      return state;
    case UPDATE_PRODUCT_LOCATION:
      if (state.data.getId() === action.item.getId()) {
        state = _.assign({}, state, {
          data: _.assign(state.data, {
            location_id: action.data.getId()
          })
        });
      }
      return state;
    default:
      return state;
  }
};

export const batch = (state = { fetched: false, items: [], codes: [], originalText: '' }, action) => {
  switch (action.type) {
    case DETECT_TYPE_OF_CODE_REQUESTED:
      return _.assign({}, state, {
        originalText: action.originalText,
        codes: _.map(action.data, item => _.assign({}, { code: item }))
      });
    case SKIP_DISPUTE_ITEM:
      return _.assign({}, state, {
        codes: state.codes.filter(s => s.code !== action.data)
      });
    case DETECT_TYPE_OF_CODE_SUCCESSED:
    case MAP_DESTINATION_TO_PRODUCT:
    case UPDATE_PRODUCT_DESTINATION:
    case UPDATE_PRODUCT_LOCATION:
      return _.assign({}, state, {
        codes: _.map(state.codes, item => Code(item, action))
      });
    default:
      return state;
  }
};
